import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Navbar.module.css';
import { isNative } from '../../platform/platform';
import backButtonIcon from '../../assets/icons/backButton.svg';
import xButtonIcon from '../../assets/icons/xButton.svg';
import hamburgerMenuIcon from '../../assets/icons/hamburgerMenu.svg';
import { InboxConnection } from '../inbox/types';
import { useLayout } from '../layout/LayoutContext';
import InboxButton from './InboxButton';
import NotificationMenuButton from './NotificationMenuButton';
import { User } from 'gql/types';
import primaryLogo from "../../assets/primary-logo.png";
import noUser from "../../assets/no-user.png";

const OVERFLOW_ZINDEX_BASE = 100;

interface NavbarProps {
  user?: User;
  title: string; // Title for the navbar
  showLogo?: boolean;
  openHamburgerMenu?: () => void;
  openProfileBubble?: () => void;
  openInbox?: (precomputedUnseenConnection?: InboxConnection) => void;
  openNotifications?: () => void;
  onBack?: () => void; // Optional custom back button behavior
  useCloseButton?: boolean;
  className?: string;
}

const Navbar: React.FC<NavbarProps> = ({
  user,
  title,
  showLogo,
  openHamburgerMenu,
  openProfileBubble,
  openNotifications,
  openInbox,
  onBack,
  useCloseButton,
  className,
}) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1); // Default behavior: go back one page
    }
  };

  const { baseZIndex } = useLayout();

  const finalZIndex = baseZIndex + OVERFLOW_ZINDEX_BASE;

  const renderMenuIcon = () => {
    if (openHamburgerMenu) {
      return <img src={hamburgerMenuIcon} />;
    }
    if (!user) {
      return <img src={noUser} />;
    }
    if (user.profilePictureUrl) {
      return <img src={user.profilePictureUrl} className={styles.avatar} />;
    }
    if (user.firstName) {
      const initial = user.firstName[0];
      return <div className={styles.initialAvatar}>{initial}</div>;
    }

    return <img src={noUser} />;
  }

  return (
    <div
      className={`navbar ${styles.navbar} ${className}`}
      style={{ zIndex: finalZIndex }}
    >
      {onBack && !openHamburgerMenu && !openProfileBubble && <div className={`${useCloseButton ? styles.closeButtonContainer : styles.backButtonContainer}`}>
        <button className={styles.navbarButton} onClick={handleBackClick}>
          {useCloseButton ? <img src={xButtonIcon} /> : <img src={backButtonIcon} />}
        </button>
      </div>}
      {openHamburgerMenu && <div className={styles.backButtonContainer}>
        <button className={styles.navbarButton} onClick={openHamburgerMenu}>
          {renderMenuIcon()}
        </button>
      </div>}
      {openProfileBubble && !openHamburgerMenu && <div className={styles.backButtonContainer}>
        <button className={styles.navbarButton} onClick={openProfileBubble}>
          {renderMenuIcon()}
        </button>
      </div>}
      <h1 className={`${styles.title} ${showLogo ? styles.hidden : ""}`}>{title}</h1>
      {<img src={primaryLogo} className={`${showLogo ? "" : styles.imageHidden} ${styles.logo}`} decoding="async" loading="lazy" alt="Plii Logo" />}
      {(openNotifications || openInbox) && (
        <div className={styles.rightContainer}>
          {openNotifications && (
            <NotificationMenuButton
              user={user}
            />
          )}
          {openInbox && (
            <InboxButton
              user={user}
              onClick={openInbox}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Navbar;
